export enum AccountType {
  Person = 'person',
  Api = 'api',
}
